<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { t } from '../i18nStore';

  let isDismissed = false;

  onMount(() => {
    isDismissed = sessionStorage.getItem('snapperk_tax_envelope_dismissed') === 'true';
  });

  function dismiss(e) {
    e.stopPropagation();
    isDismissed = true;
    sessionStorage.setItem('snapperk_tax_envelope_dismissed', 'true');
  }

  function openCalculator() {
    navigate('/tax-calculator');
  }
</script>

{#if !isDismissed}
  <div class="tax-envelope-fab" on:click={openCalculator} role="button" tabindex="0">
    <!-- Icon Container -->
    <div class="envelope-badge">
      <span class="icon">✉️</span>
      <span class="calc-icon">⚡</span>
    </div>

    <!-- Text details -->
    <div class="text-content">
      <span class="title">{$t('tax.fab_title')}</span>
      <span class="subtitle">{$t('tax.fab_subtitle')}</span>
    </div>

    <!-- Close button -->
    <button class="close-btn" on:click={dismiss} title={$t('tax.fab_dismiss')} aria-label={$t('tax.fab_dismiss')}>
      ✕
    </button>
  </div>
{/if}

<style>
  .tax-envelope-fab {
    position: fixed;
    bottom: 24px;
    left: 24px;
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 10px;
    background: #1b5e20;
    border: 2px solid #4caf50;
    color: white;
    padding: 8px 14px;
    border-radius: 30px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3), 0 0 12px rgba(76, 175, 80, 0.4);
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    user-select: none;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .tax-envelope-fab:hover {
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35), 0 0 16px rgba(76, 175, 80, 0.6);
  }

  .envelope-badge {
    position: relative;
    background: rgba(255, 255, 255, 0.2);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }

  .calc-icon {
    position: absolute;
    bottom: -2px;
    right: -2px;
    background: #002366;
    color: #ffd700;
    font-size: 9px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .text-content {
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.3px;
  }

  .subtitle {
    font-size: 10px;
    color: #ffd700;
    font-weight: 600;
  }

  .close-btn {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: 2px;
    transition: background 0.2s;
  }

  .close-btn:hover {
    background: rgba(255, 255, 255, 0.35);
  }

  @media (max-width: 600px) {
    .tax-envelope-fab {
      bottom: 20px;
      left: 16px;
      padding: 6px 12px;
    }
  }
</style>
